import { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { MARKDOWN_TABLE_SX, REMARK_PLUGINS } from './markdown';
import { readResult } from './reduceEvents';

const COLLAPSED_HEIGHT = 120;

/** What an agent returned, as markdown: long text starts folded, and a structured result shows its summary with the data behind a toggle. */
export function ResultText({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);
  const [showData, setShowData] = useState(false);
  const result = readResult(text);
  const long = result.text.length > 400 || result.text.split('\n').length > 6;

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          overflowWrap: 'anywhere',
          fontSize: '0.875rem',
          maxHeight: long && !expanded ? COLLAPSED_HEIGHT : 'none',
          ...(long && !expanded ? { maskImage: 'linear-gradient(to bottom, black 60%, transparent)' } : {}),
          '& p': { my: 0.75 },
          '& p:first-of-type': { mt: 0 },
          '& ul, & ol': { my: 0.75, pl: 2.5 },
          '& code': { bgcolor: 'action.hover', px: 0.5, borderRadius: 0.5, fontFamily: 'monospace', fontSize: '0.85em' },
          ...MARKDOWN_TABLE_SX,
        }}
      >
        <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{result.text}</ReactMarkdown>
      </Box>
      {(long || result.data) && (
        <Stack direction="row" spacing={1}>
          {long && (
            <Button size="small" onClick={() => setExpanded(!expanded)} sx={{ px: 0, minWidth: 0 }}>
              {expanded ? 'Show less' : 'Show more'}
            </Button>
          )}
          {result.data && (
            <Button size="small" onClick={() => setShowData(!showData)} sx={{ px: 0, minWidth: 0 }}>
              {showData ? 'Hide saved data' : 'Show saved data'}
            </Button>
          )}
        </Stack>
      )}
      {showData && result.data && (
        <Box component="pre" sx={{ m: 0, p: 1.5, bgcolor: 'action.hover', borderRadius: 1, fontSize: '0.75rem', maxHeight: 320, overflow: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
          {JSON.stringify(result.data, null, 2)}
        </Box>
      )}
    </Box>
  );
}
